import { PRODUCTIVE_MODE, SANDBOX_MODE } from './authorizationModeType';

export function validateMode(mode) {
  if (!mode) throw new Error(`Mode must be provided`);
  if (mode !== PRODUCTIVE_MODE && mode !== SANDBOX_MODE) throw new Error('Invalid mode');
}
